import { usePermissions } from 'permissions';
import { Card, Icon, withErrorBoundary } from 'ui';
import { AssetsHeaderButtons, AssetsTable, useAssetsFoldersParents } from 'features/assets';
import { ProgramLayout } from '../program-layout';

type P = {
  programId: string;
};

const ProgramAssets = ({ programId }: P) => {
  const { canManageProgram } = usePermissions();
  const { addParentFolder, lastParentFolder, navigateToParentFolder, navigateToRoot, parents } =
    useAssetsFoldersParents();

  return (
    <ProgramLayout programId={programId}>
      {(program) => {
        const canManage = canManageProgram({ program });

        return (
          <Card
            extra={canManage ? <AssetsHeaderButtons parentId={lastParentFolder?.id} programId={programId} /> : null}
            title={<Card.Title icon={<Icon icon="folder-line" />}>All Folders</Card.Title>}
          >
            <AssetsTable
              canManage={canManage}
              filter={{ programId }}
              folders={parents}
              onNavigateToParentFolder={navigateToParentFolder}
              onNavigateToRoot={navigateToRoot}
              onOpenFolder={addParentFolder}
              parentFolder={lastParentFolder}
            />
          </Card>
        );
      }}
    </ProgramLayout>
  );
};

export default withErrorBoundary(ProgramAssets);
